import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type SignalRStatus = 'uninitialized' | 'initializing' | 'connected' | 'reconnecting' | 'disconnected';
export const maxSignalRDisconnects = 2;

interface SignalRState {
    status: SignalRStatus,
    disconnects: number
}

const initialState: SignalRState = {
    status: 'uninitialized',
    disconnects: 0,
};

export const signalRSlice = createSlice({
    initialState,
    name: 'signalR',
    reducers: {
        setSignalRStatus(state, action: PayloadAction<SignalRStatus>) {
            state.status = action.payload;
            if (state.status === 'disconnected') {
                state.disconnects++;
            }
        },
    },
});

export const { setSignalRStatus } = signalRSlice.actions;
